import { get } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'

export const createCorrectionRequest = () => ({
    type: type.CREATE_CORRECTION_REQUEST,
    payload: {},
})

export const createCorrectionSuccess = (invoice) => ({
    type: type.CREATE_CORRECTION_SUCCESS,
    payload: {
        invoice,
    },
})

export const createCorrectionError = (error) => ({
    type: type.CREATE_CORRECTION_ERROR,
    payload: {
        error,
    },
})


export const createCorrection = (callback) => (dispatch, getState) => {
    const state = getState()
    const invoice = selector.selectInvoice(state)
    if (!invoice) {
        return null
    }
    dispatch(createCorrectionRequest())

    get('/api/invoice/create-correction?invoiceId=' + invoice.id)
        .then(invoiceCorrection => {
            dispatch(createCorrectionSuccess())
            callback(invoiceCorrection)
        })
        .catch(error => {
            dispatch(createCorrectionError(error))
        })
}

export const showConfirmationModal = (invoice) => ({
    type: type.SHOW_CONFIRMATION_MODAL,
    payload: {
        invoice,
    },
})

export const closeConfirmationModal = () => ({
    type: type.CLOSE_CONFIRMATION_MODAL,
})



// WEBPACK FOOTER //
// ./src/modules/invoice/state/display/action.js